export default {
  paged: {
    select: 'id,type,name,description,isActive,validated,isPublic',
    searchSelect: ['name', 'description'],
    expand: {
      group: { select: 'name' },
    },
  },
  // `item` feeds the edit form — the `canManage` flag was already
  // evaluated on the list to decide whether to allow opening the edit
  // drawer, so there's no need to request it again here. Keep it only
  // on the listing endpoints.
  item: {
    select: 'id,type,name,description,isActive,isPublic,permissions,groupId',
    expand: {
      group: { select: 'name' },
    },
  },
  itemDetail: {
    select:
      'id,type,name,description,isActive,isPublic,validated,permissions,configurations,created,updated,creator,modifier',
    expand: {
      group: { select: 'name' },
    },
  },
};
